app.controller('BrowseLayoutMethodInputController', ['$rootScope', '$scope', function ($rootScope, $scope) {

    const navigationIDs = $scope.navigation_ids;

    $scope.method_input_model = $rootScope.factory.method_input.getModel(navigationIDs);


    function requireChildState() {
        $rootScope.navigation_manager.requireChildState("method_input");
    }

    if (navigationIDs.browse_id !== "solution") {
        requireChildState();

        $scope.$on('browse_navigation_state_change', function () {
            requireChildState();
        });
    }
}])